export default "__VITE_ASSET__DsTIIfoc__"